export default __webpack_public_path__ + "static/media/Flamelash Gloves.f369e0dc.jpg";